import EmptySearchIcon from '@clearkit/icons/glyphs/NoResults';

import { readableSegmentType } from '~/lib/segments';

const EmptySearch = ({ searchQuery, inSegment, segmentType }) => {
  return (
    <div className="flex flex-col items-center text-center w-xxs">
      <EmptySearchIcon width={40} height={40} className="text-gray-200" />
      <h1 className="mt-3 mb-1 text-base font-normal text-gray">
        There are no {readableSegmentType(segmentType)}{' '}
        {inSegment && 'in this segment '}matching{' '}
        <span className="font-semibold ck-highlight">{searchQuery}</span>
      </h1>
    </div>
  );
};

EmptySearch.propTypes = {
  searchQuery: PropTypes.string,
  inSegment: PropTypes.bool,
  segmentType: PropTypes.string,
};

export default EmptySearch;
